// NATIVE
import React, { useEffect, useState } from 'react';

// INSTALLED
import { useFormikContext } from 'formik';
import { Button, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

// CUSTOM
import InputNumeric from 'components/formFields/InputNumeric';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PersonAdd from '@mui/icons-material/PersonAdd';
// import { DinamicFamilia } from './dinamicFamilia/DinamicFamilia'
import { storeFamilyBeneficiarios } from 'store/size_family';
import { EditDinamicFamilia } from './dinamicFamilia/EditDinamicFamilia';

export const EditFamilia = (props: any) => {
  // DISPATCH
  const dispatch = useDispatch();

  // REDUX
  const { sizeFamilyBeneficiarios }: any = useSelector((state: any) => state.sizefamily);

  const { employee } = useSelector((state: any) => state.employee);

  const formikProps: any = useFormikContext();

  useEffect(() => {
    if (employee && Object.keys(employee).length > 0) {
      setEmployeeData(employee);
    }
  }, [employee]);

  const setEmployeeData = async (employee: any) => {
    if (formikProps.values.is_initialized_familia) return;
    formikProps.setFieldValue('is_initialized_familia', true);
    if (employee && employee.beneficiaries && employee.beneficiaries.length > 0) {
      const parentesco_list = [
        { label: 'conyuge', value: 'Cónyuge' },
        { label: 'hijo', value: 'Hijo' },
        { label: 'hijastro', value: 'Hijastro' },
        { label: 'padre', value: 'Padre' },
        { label: 'madre', value: 'Madre' },
      ];
      const genderList = [
        { label: 'masculino', value: 'masculino' },
        { label: 'femenino', value: 'Femenino' },
        { label: 'otro', value: 'otro' },
      ];
      const escolaridadList = [
        { label: 'primaria', value: 'primaria' },
        { label: 'bachillerato', value: 'bachillerato' },
        { label: 'tecnico', value: 'tecnico' },
        { label: 'tecnologo', value: 'tecnologo' },
        { label: 'postgrado', value: 'postgrado' },
      ];

      const beneficiariesFormatted = employee.beneficiaries.map((beneficiary: any) => {
        const parentescoObj =
          parentesco_list.find(
            (p) => p.value.toLowerCase() === beneficiary.parentesco?.toLowerCase()
          ) || null;
        const generoObj =
          genderList.find((g) => g.value.toLowerCase() === beneficiary.genero?.toLowerCase()) ||
          null;
        const escolaridadObj =
          escolaridadList.find(
            (e) => e.value.toLowerCase() === beneficiary.escolaridad?.toLowerCase()
          ) || null;

        return {
          ...beneficiary,
          parentesco: parentescoObj,
          genero: generoObj,
          escolaridad: escolaridadObj,
          fecha_nacimiento: beneficiary.birthdate, // Renombrar birthdate
          action: 'editar', // Marcar como existente para editar
          editarId: beneficiary.id, // Guardar el ID original
          // type_document ya viene como objeto, no necesita transformación.
        };
      });

      formikProps.setFieldValue('family', beneficiariesFormatted); // 🔹 Actualiza Formik
      await dispatch(storeFamilyBeneficiarios(beneficiariesFormatted)); // 🔹 Opcional: actualiza Redux si necesitas
    }
  };

  const addMember = async () => {
    const newMember = {
      parentesco: null,
      type_document: null,
      num_document: '',
      nombre: '',
      apellido: '',
      genero: null,
      fecha_nacimiento: null,
      escolaridad: null,
      ocupacion: '',
      documento_beneficiario: null,
      action: 'crear', // Marcar como nuevo para crear
    };

    const currentFamily = Array.isArray(formikProps.values.family)
      ? [...formikProps.values.family]
      : [];
    const updatedFamily = [...currentFamily, newMember];

    formikProps.setFieldValue('family', updatedFamily);
    await dispatch(storeFamilyBeneficiarios(updatedFamily));
  };

  const {
    formField: {
      // DATOS CLIENTE
      numOfBeneficiary,
    },
  } = props;

  return (
    <>
      <Grid size={{ xs: 3 }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddCircleIcon />}
          endIcon={<PersonAdd />}
          onClick={addMember} // esta es tu función para agregar un beneficiario
          sx={{ mt: 2, borderRadius: 2 }}
        >
          Agregar Beneficiario
        </Button>
      </Grid>

      <EditDinamicFamilia family={formikProps.values.family} onOpenPdf={props.onOpenPdf} />
    </>
  );
};
